import { UserType } from "src/model";

export const menuOptions = [
    {
        title: 'Dashboard',
        path: '/admin/dashboard',
        userType: UserType.ADMIN
    },
    {
        title: 'Reports',
        path: '/admin/reports',
        userType: UserType.ADMIN
    },
    {
        title: 'Administration',
        path: '/admin/administration',
        userType: UserType.ADMIN
    },
    {
        title: 'Users',
        path: '',
        basePath: '/users',
        userType: UserType.ADMIN,
        options: [
            {value: '/admin/users/admin', label: 'Admin users'},
            {value: '/admin/users/institution', label: 'Institution users'}
        ]
    },
    {
        title: 'Audit',
        path: '/admin/audit',
        userType: UserType.ADMIN
    },
    {
        title: 'Discover',
        path: '/client/discover',
        userType: UserType.CLIENT
    },
    {
        title: 'Store',
        path: '/client/store',
        userType: UserType.CLIENT
    },
    {
        title: 'Settings',
        path: '/client/settings',
        userType: UserType.CLIENT
    },
    {
        title: 'Users',
        path: '/client/users',
        userType: UserType.CLIENT
    },
    {
        title: 'Audit',
        path: '/client/audit',
        userType: UserType.CLIENT
    },
    {
        title: 'Billing',
        path: '/client/billing',
        userType: UserType.CLIENT
    },
    {
        title: 'Products',
        path: '/partner/products',
        userType: UserType.PARTNER
    },
    {
        title: 'API management',
        path: '',
        basePath: '/api-management',
        userType: UserType.PARTNER,
        options: [
            {value: '/partner/api-management/configuration', label: 'API Configuration'},
            {value: '/partner/api-management/integration', label: 'API Integration'}
        ]
    },
    {
        title: 'Users',
        path: '/partner/users',
        userType: UserType.PARTNER
    },
    {
        title: 'Audit',
        path: '/partner/audit',
        userType: UserType.PARTNER
    }
]